<template>
  <div class="home" :style="homeStyle">
    <pageHeader>
    </pageHeader>
    <div class="titleBlock">
      <div class="title">
        请选择查询内容
      </div>
      <div class="shareBlock" @click="share" v-show="showShare">
        <img :src="imageMap.share20200130" alt="" class="shareIcon">
        <div class="shareText">
          分享给更多人
        </div>
      </div>
    </div>
    <div>
      <card v-for="( item, index ) in cardList" :key="index" :cardInfo="item">
      </card>
    </div>
    <div class="searchBlock">
      <div class="searchText" @click="showAll">
        显示全部
      </div>
      <div class="searchText" v-if="isNative" @click="searchUserTrip">
        我的行程查询
      </div>
    </div>
    <pageFooter>
    </pageFooter>
    <shareLayer v-if="showShareLayer" @clickShareLayer="closeShareLayer">
    </shareLayer>
  </div>
</template>

<script>
  import card       from './card.vue';
  import imageMap   from '../../image-map.js';
  import pageFooter from './page-footer.vue';
  import service    from '../../service/index.js';
  import ui         from '@/ui/index.js';
  // import wechatTool from '@/utils/weixinApi.js';
  import shareLayer from './share-layer.vue';
  import env        from '@/utils/env.js';
  import pageHeader from './page-header.vue';
  import auth       from '@/request/auth.js';

  import { mapMutations, mapState } from 'vuex';

  export default {
    components : { card, pageFooter, shareLayer, pageHeader },

    data() {
      return {
        imageMap,

        showShareLayer : false,
        showShare      : false,

        allCardList : [ {
          icon    : imageMap.trainIcon,
          title   : '查询您乘坐的火车',
          content : '输入日期/车次，查看该车次是否有肺炎患者同行',
          color   : '#34a853',
          type    : 'train'
        }, {
          icon    : imageMap.flightIcon,
          title   : '查询您乘坐的飞机',
          content : '输入日期/航班号，查看该航班是否有肺炎患者同行',
          color   : '#12c8d7',
          type    : 'flight'
        }, {
          icon    : imageMap.hotelIcon,
          title   : '按城市查询',
          content : '查看该城市中是否有肺炎患者出现的航班/火车/公交/地点',
          color   : '#ff5269',
          type    : 'city'
        } ]
      };
    },

    computed : {
      ...mapState( 'virusTrip', [
        'searchType', 'searchDate', 'travelNumber', 'city'
      ] ),

      cardList() {
        let result;

        const ptid = JSON.parse( localStorage.getItem( 'ptid' ) );

        if ( ptid === 'huaxiaair' ) {
          result = this.allCardList.slice( 1 );
        } else {
          result = this.allCardList;
        }

        return result;
      },

      isHuaZhu() {
        return /huazhu/i.test( navigator.userAgent );
      },

      isCmb() {
        return /mpbank/i.test( navigator.userAgent );
      },

      isAbc() {
        return /bankabc/i.test( navigator.userAgent );
      },

      isNative() {
        const ptid = JSON.parse( localStorage.getItem( 'ptid' ) );

        return ptid === 'hbgj' || ptid === 'gtgj';
      },

      homeStyle() {
        const ptid = JSON.parse( localStorage.getItem( 'ptid' ) );

        return ptid === 'ABC' ? {
          paddingTop : '40px'
        } : {};
      }
    },

    methods : {
      ...mapMutations( 'virusTrip', [
        'updateAllVirusTrip', 'updateSearchType',   'updateUpdateTime',
        'updateSearchDate',   'updateTravelNumber', 'updateCity',
        'updateFilterList',   'updateUserVirusTrip'
      ] ),

      setPageTitle( title ) {
        document.title = title;
      },

      setPageColor( color ) {
        document.body.style.backgroundColor = color;
      },

      showAll() {
        this.updateSearchType( 'all' );
        this.updateSearchDate( '' );
        this.updateTravelNumber( '' );
        this.updateCity( '' );
        this.updateFilterList( [ 'flight', 'train', 'other' ] );

        const ptid = JSON.parse( localStorage.getItem( 'ptid' ) );

        ha( 'send', 'click', {
          eventId : 'search_all',
          bizsys  : 'bjyf',
          actId   : 'fy_transport',
          eventAttr : JSON.stringify( {
            type   : 'all',
            source : ptid
          } )
        } );

        this.$router.push( {
          path : '/virusTrip/searchResult',

          query : {
            searchType   : this.searchType,
            searchDate   : this.searchDate,
            travelNumber : this.travelNumber,
            city         : this.city
          }
        } );
      },

      share() {
        this.showShareLayer = true;
      },

      closeShareLayer() {
        this.showShareLayer = false;
      },

      searchUserTrip() {
        auth.login().then( () => {
          return ui.withLoading( service.queryUserVirusTrip )();
        } ).then( ( data ) => {
          this.updateSearchType( 'user' );
          this.updateUserVirusTrip( data.list || [] );

          this.$router.push( {
            path : '/virusTrip/searchResult'
          } );
        } );
      }
    },

    mounted() {
      this.setPageTitle( '新冠肺炎确诊患者同行程查询' );
      this.setPageColor( '#eeeeee' );

      const ptid = JSON.parse( localStorage.getItem( 'ptid' ) );

      // wechatTool.share( {
      //   title  : '新冠肺炎确诊患者同乘旅客查询工具',
      //   desc   : '与全国人民一起共同抗击新冠肺炎，武汉加油！中国加油！',
      //   link   : 'https://h5.133.cn/gtgjwap/h5/virusTrip/home',
      //   img    : 'https://cdn.133.cn/gtgj/web/virusTrip/share-icon.jpeg'
      // } );

      setTimeout( () => {
        const hideSharePtidList = [
          'dxys',        'jegotrip',      'guangdayh', 'opponr',
          'opponrother', 'zhaoshangbank', 'ABC',       'zaitushanglv',
          'zfbhb',       'zfbgt',         'xiaomi',    'kuping',
          'huaxiaair',   'xiaomijinrong'
        ];

        this.showShare = (
          !env.isWeixinMiniProgram
          && !env.isNative
          && !this.isHuaZhu
          && hideSharePtidList.indexOf( ptid ) < 0
          && !this.isCmb
          && !this.isAbc
        );
      }, 1000 );

      ha( 'send', 'page_open', {
        eventId : 'fycx_page',
        bizsys  : 'bjyf',
        actId   : 'fy_transport',

        eventAttr : JSON.stringify( {
          source : ptid
        } )
      } );

      ui.withLoading( service.queryVirusTrip )().then( ( result ) => {
        console.log( result );

        if ( result && result.list ) {
          this.updateAllVirusTrip( result.list );
          this.updateUpdateTime( result.updatetime );
        }
      } );
    }
  };
</script>

<style>
  body {
    user-select : none;
    margin      : 0 auto;
    font-family : "Avenir", "PingFang SC";
  }
</style>

<style scoped lang="scss">
  @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/projects/virusTrip/pages/home/index.vue